import { Button } from "../_app.style";
import { styled } from '../stitches.config';

export const SelectButton = styled(Button, {
    display: 'flex',
    justifyContent: 'flex-start', // <-- ADD THIS LINE
    backgroundColor: 'transparent',
    gap: '0.75rem',

    
    // --- 1. Set the default text style ---
    color: '#000000',      // Always black
    fontSize: '0.875rem',  // Smaller font size (14px)
  
    // Transition now only applies to the background
    transition: 'background-color 0.2s ease',
  
    // --- 2. Remove the color change from the hover state ---
    '&:not([data-active="true"]):hover': {
      backgroundColor: '$blueHover',
      '& svg': {
      fill: 'var(--colors-blue11)',
    },  
    '& span': {
      color: 'var(--colors-blue11)', // For the text
    },
    },
  
    variants: {
      active: {
        true: {
          backgroundColor: '$blueHover',
          '& svg': {
            fill: 'var(--colors-blue11)',
          },
          '& span': {
            color: 'var(--colors-blue11)', // For the text
          },
      
          // --- 3. Remove the color change from the active state ---
          // The 'color' property is removed, so it stays black
        },
      },
    },
  });


  export const PhotoWrapper = styled('div', {
    width: '100%',
    maxWidth: '320px',
    aspectRatio: '1 / 1', // keep it square
    
    borderRadius: '50%', // Creates the circle shape
    overflow: 'hidden', // Ensures the image inside is clipped to the circle
    margin: '0 auto', // Center the photo wrapper within the card
  
    // For centering the fallback icon
    display: 'grid',
    placeItems: 'center',
  
    // --- This variant handles the conditional border color ---
    variants: {
      hasPhoto: {
        true: {
          border: '2px solid #28a745', // A nice, noticeable green
        },
        false: {
          border: '2px solid #000000', // Black border for the fallback
          backgroundColor: '$gray3', // A light grey background for the icon
        },
      },
    },
  });
  
  export const StyledImage = styled('img', {
    width: '100%',
    height: '100%',
    objectFit: 'cover', // Crucial: ensures the photo fills the circle without distortion
  });
  

  export const ActionButton = styled(Button, {
    // --- Base styles applied to ALL variants ---
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // flex: 1, // So they easily fill footers
    padding: '0.5rem 1rem',
    fontSize: '0.9rem',
    fontWeight: '500',
    borderRadius: '8px',
    border: 'none', // Remove default borders
  
    // --- Add the Swell Animation Here! ---
    // This transition will apply to all variants automatically
    transition: 'transform 0.2s ease-in-out, background-color 0.2s ease-in-out',
    
    '&:not(:disabled):hover': {
      cursor: 'pointer',
      transform: 'scale(1.05)', // The "swell" effect
    },
  
    '&:not(:disabled):active': {
      transform: 'scale(0.98)', // The "press" effect
    },
  
    '&:disabled': {
      opacity: 0.6,
      cursor: 'not-allowed',
    },
  
    // --- Define the different button types ---
    variants: {
      intent: {
        primary: { // For "Save", "Confirm", "Submit"
          backgroundColor: '$green3', // Using Stitches color tokens
          border: '1px solid $green8',
          color: '$green11', 
          // color: 'white',
          '&:hover': {
            backgroundColor: '$green4',
          },
        },

        background: { // For "Save", "Confirm", "Submit"
          backgroundColor: 'transparent', // Using Stitches color tokens
          // color: 'white',
          '&:hover': {
            backgroundColor: 'transparent',
          },
        },

        secondary:  {
          backgroundColor: '$elementBackground',
          '&:hover': { backgroundColor: '$elementHover' },
          '&:active': { backgroundColor: '$elementActive' },

        
        // backgroundColor: '$red5', // Using Stitches color tokens
        // border: '1px solid $red8',
        // color: '$red11', 
        // // color: 'white',
        // '&:hover': {
        //   backgroundColor: '$red6',
        // },
      },
      
        danger: { // For "Delete", "Remove"
          backgroundColor: '$red4',
          border: '1px solid $red8',
          color: '$red11',
          '&:hover': {
            backgroundColor: '$red6',
          },
        },
      },
    },
  
    // --- Set a default style if no intent is provided ---
    defaultVariants: {
      intent: 'secondary',
    },
  });